import { Component, Input, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {AuthenticationService} from "../../services/auth.service";
import { Router, RouterLink } from "@angular/router";
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgOptimizedImage, NgClass } from '@angular/common';
import { KazHeaderSearchComponent } from '../../components/kaz-header-search/kaz-header-search.component';
import { KazDesktopNavComponent } from '../../components/kaz-desktop-nav/kaz-desktop-nav.component';
import { KazFooterComponent } from '../../components/kaz-footer/kaz-footer.component';
import { KazDefaultInfoComponent } from '../../components/kaz-default-info/kaz-default-info.component';
import { KazMenuComponent } from '../../components/kaz-menu/kaz-menu.component';

@Component({
    selector: 'kaz-default-frame',
    templateUrl: './default-frame.component.html',
    styleUrls: ['./default-frame.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent, RouterLink, NgOptimizedImage, KazHeaderSearchComponent, KazDesktopNavComponent, KazFooterComponent, NgClass, KazDefaultInfoComponent, KazMenuComponent]
})
export class DefaultFrameComponent implements OnInit {
  _auth = inject(AuthenticationService);
  private _router = inject(Router);


  @Input() scrollable: boolean = true;

  backLink: string = "";
  showMenu: boolean = false;

  showAuthBtns: boolean = false;
  mail: string = "";

  ngOnInit() {
    this.isAuthenticated();
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  isProfilePage(): boolean {
    return this._router.url.includes('/profile');
  }

  isAuthenticated() {
    this.showAuthBtns = !this._auth.isAuthenticated();
    const claims = this._auth.getClaimsFromToken();
    if (claims !== null) {
      if (claims.userType === 'WEB_USER') {
        this.mail = claims.mail;
      }
      if (claims.userType === 'ADMIN_USER') {
        this._auth.clearAuth();
        this._router.navigate(['login']).then();
      }
    }
  }

  closeMenu() {
    this.showMenu = false;
  }

  logout() {
    this._auth.clearAuth();
  }
}

